export default __webpack_public_path__ + "static/media/blessedsoul.2addb38d.png";